module.exports = __webpack_public_path__ + "static/media/chart_3d_img.e4aba1b3.svg";